<div #content class="content-frame">
    <div class="title">Lazada</div>
    @for (store of stores; track store.name) {
    <div style="margin-top: 15px">
        <div class="store-name">{{ store.name }}</div>
        <div style="margin-top: 5px">
            <dx-button
                text="Get Authorization Code"
                width="200"
                (onClick)="navigateLazadaAuth(store)"
            ></dx-button>
        </div>
    </div>
    }
</div>

<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#content' }"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
>
</dx-load-panel>
